const __WEBPACK_NAMESPACE_OBJECT__ = require("html-inline-css-webpack-plugin");